export default __webpack_public_path__ + "static/media/icon-Instagram.b4f6064c.svg";